export var isRefinement = function (codec) {
    return '_tag' in codec && codec._tag === 'RefinementType';
};
